interface Props {
  setPersonDetected: Function;
}
const PersonDetectedModal: React.FC<Props> = ({ setPersonDetected }) => {
  return (
    <>
      <div className="person-detected-modal text-center flex-column">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="343"
          viewBox="0 0 240 343"
          fill="none"
        >
          <rect opacity="0.4" y="282" width="240" height="61" fill="#0F854C" />
          <path
            d="M150.297 30C150.297 46.5687 136.73 60 120.009 60C103.288 60 89.7214 46.5687 89.7214 30C89.7214 13.4312 103.288 0 120.009 0C136.73 0 150.297 13.4312 150.297 30ZM114.961 220V300C114.961 311.062 105.938 320 94.7693 320C83.6007 320 74.5776 311.062 74.5776 300V160.562L56.5501 190.312C50.8081 199.75 38.4028 202.812 28.8433 197.125C19.2835 191.438 16.1913 179.188 21.9358 169.688L58.7081 109.125C69.6558 91.0625 89.3428 80 110.607 80H129.411C150.675 80 170.362 91.0625 181.341 109.125L218.065 169.688C223.807 179.188 220.715 191.438 211.187 197.125C201.596 202.812 189.229 199.75 183.487 190.312L165.44 160.562V300C165.44 311.062 156.417 320 145.249 320C134.08 320 125.057 311.062 125.057 300V220H114.961Z"
            fill="#802392"
          />
        </svg>
        <h1
          style={{ paddingTop: "32px" }}
          className="fz-30 fw-700 text-center lh-normal mb-0 align-center"
        >
          Person Detected
        </h1>
      </div>
    </>
  );
};
export default PersonDetectedModal;
